import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRight, Sparkles, Star, Shield, Clock } from 'lucide-react';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="relative pt-6 pb-16 md:pt-10 md:pb-24 overflow-hidden bg-gradient-to-b from-[#FDFBF7] to-white" data-id="element-968">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
      backgroundImage: 'radial-gradient(circle at 1px 1px, #2D5016 1px, transparent 0)',
      backgroundSize: '32px 32px'
    }} data-id="element-969"></div>

      <div className="container mx-auto px-4 max-w-6xl relative" data-id="element-970">
        {/* Trust bar above headline */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="flex justify-center mb-6" data-id="element-971">
          <div className="flex items-center gap-4 bg-white border border-[#D4AF37]/30 rounded-full px-5 py-2 shadow-sm flex-wrap justify-center gap-y-1" data-id="element-972">
            <div className="flex items-center gap-1.5" data-id="element-973">
              <div className="flex" data-id="element-974">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-3.5 h-3.5 fill-[#D4AF37] text-[#D4AF37]" data-id="element-975" />)}
              </div>
              <span className="text-xs font-bold text-gray-700" data-id="element-976">4.9/5</span>
            </div>
            <span className="w-px h-4 bg-gray-200" data-id="element-977"></span>
            <span className="text-xs font-semibold text-gray-600" data-id="element-978">
              +10,000 clientas satisfechas
            </span>
            <span className="w-px h-4 bg-gray-200" data-id="element-979"></span>
            <span className="text-xs font-semibold text-green-700 flex items-center gap-1" data-id="element-980">
              <Shield className="w-3 h-3" data-id="element-981" /> Garantía 90 días
            </span>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-982">
          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="order-2 md:order-1" data-id="element-983">
            <div className="inline-flex items-center gap-2 bg-red-50 text-red-700 px-3 py-1.5 rounded-full text-xs font-black uppercase tracking-wider mb-5 border border-red-100" data-id="element-984">
              <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse" data-id="element-985"></span>
              🔥 Últimas Unidades — Oferta Termina Hoy
            </div>

            <h1 className="md:text-5xl lg:text-6xl font-extrabold text-gray-900 mb-5 text-[40px]" data-id="element-986">
              Hasta 8 kg menos en 21 días — sin inyecciones, dietas estrictas ni
              pastillas.
            </h1>

            <p className="text-xl text-gray-700 mb-2 font-semibold leading-snug" data-id="element-987">
              StingFit™ activa el drenaje linfático y ayuda a quemar grasa
              abdominal incluso mientras duermes.
            </p>

            <p className="text-base text-gray-500 mb-7 leading-relaxed" data-id="element-988">
              Tecnología transdérmica de última generación. Un parche al día.
              Resultados visibles en 7 días o te devolvemos el dinero.
            </p>

            <div className="space-y-2.5 mb-8" data-id="element-989">
              {[{
              text: 'Hasta 8 kg en 21 días — resultados reales verificados',
              hot: true
            }, {
              text: 'Activa el metabolismo y quema grasa localizada',
              hot: false
            }, {
              text: 'Reduce la hinchazón abdominal visible desde el día 1',
              hot: false
            }, {
              text: 'Drenaje linfático natural mientras duermes',
              hot: false
            }, {
              text: 'Sin pastillas · 100% tópico · Un parche al día',
              hot: false
            }].map((benefit, i) => <div key={i} className={`flex items-center gap-3 ${benefit.hot ? 'bg-[#D4AF37]/10 -mx-3 px-3 py-2 rounded-xl' : ''}`} data-id="element-990">
                  <CheckCircle2 className={`w-5 h-5 flex-shrink-0 ${benefit.hot ? 'text-[#D4AF37]' : 'text-[#2D5016]'}`} data-id="element-991" />
                  <span className={`text-sm font-medium ${benefit.hot ? 'text-gray-900 font-bold' : 'text-gray-700'}`} data-id="element-992">
                    {benefit.text}
                  </span>
                  {benefit.hot && <span className="ml-auto text-xs bg-[#D4AF37] text-white px-2 py-0.5 rounded-full font-bold" data-id="element-993">
                      ⭐ TOP
                    </span>}
                </div>)}
            </div>

            <div className="flex flex-col gap-3" data-id="element-994">
              <Button size="xl" className="w-full group relative overflow-hidden shadow-2xl hover:shadow-[#D4AF37]/40 transition-all duration-300 hover:-translate-y-1" onClick={() => document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-995">
                <span className="relative z-10 flex items-center justify-center font-black tracking-wide" data-id="element-996">
                  SI, QUIERO RECUPERAR MI FIGURA
                </span>
              </Button>
              <p className="text-xs text-center text-green-700 font-bold mt-1" data-id="element-997">
                💰 Pago contra entrega en la puerta de tu casa
              </p>

              <div className="flex items-center justify-center gap-4 text-xs font-semibold text-gray-500 flex-wrap" data-id="element-998">
                <span className="flex items-center gap-1" data-id="element-999">
                  <CheckCircle2 className="w-3.5 h-3.5 text-green-600" data-id="element-1000" /> Envío
                  Gratis Hoy
                </span>
                <span className="flex items-center gap-1" data-id="element-1001">
                  <CheckCircle2 className="w-3.5 h-3.5 text-green-600" data-id="element-1002" />{' '}
                  Garantía 90 Días
                </span>
                <span className="flex items-center gap-1" data-id="element-1003">
                  <CheckCircle2 className="w-3.5 h-3.5 text-green-600" data-id="element-1004" /> Pago
                  100% Seguro
                </span>
              </div>

              {/* Social proof avatars */}
              <div className="flex items-center justify-center gap-3 mt-1 bg-green-50 rounded-2xl py-3 px-4 border border-green-100" data-id="element-1005">
                <div className="flex -space-x-2" data-id="element-1006">
                  {[32, 45, 67, 78].map(i => <div key={i} className="w-8 h-8 rounded-full border-2 border-white bg-gray-200 overflow-hidden" data-id="element-1007">
                      <img src={`https://randomuser.me/api/portraits/women/${i}.jpg`} alt="User" data-id="element-1008" />
                    </div>)}
                </div>
                <div className="text-left" data-id="element-1009">
                  <p className="font-black text-gray-900 text-sm" data-id="element-1010">
                    +10,000 mujeres
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-1011">
                    ya han transformado su cuerpo este mes
                  </p>
                </div>
                <div className="ml-auto text-right hidden sm:block" data-id="element-1012">
                  <p className="text-xs font-bold text-green-700" data-id="element-1013">
                    94% ven resultados
                  </p>
                  <p className="text-xs text-gray-400" data-id="element-1014">en menos de 14 días</p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="order-1 md:order-2 relative" data-id="element-1015">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl ring-4 ring-[#D4AF37]/20" data-id="element-1016">
              <img src="https://cdn.magicpatterns.com/uploads/dFPBUFJSxve5eZXCiqp6GP/imgi_10_1754196580-Copy_of_BeeBalm_–_lindrar_ledvark,_ischias,_artrit_och_halsporre_pa_bara_15_minuter_(4).png" alt="StingFit - Parche de veneno de abeja para drenaje linfático" className="w-full h-full object-contain bg-white" data-id="element-1017" />
              {/* Overlay badge */}
              <div className="absolute top-4 right-4 bg-red-600 text-white text-xs font-black px-3 py-1.5 rounded-full shadow-lg uppercase tracking-wide" data-id="element-1018">
                Stock Limitado
              </div>
            </div>

            {/* Floating testimonial badge */}
            <motion.div animate={{
            y: [0, -6, 0]
          }} transition={{
            duration: 3,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="absolute -bottom-6 -left-6 bg-white rounded-2xl p-4 shadow-2xl max-w-[220px] border-2 border-[#D4AF37]" data-id="element-1019">
              <div className="flex items-center gap-2 mb-1" data-id="element-1020">
                <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse" data-id="element-1021"></div>
                <span className="text-xs font-black text-green-700 uppercase" data-id="element-1022">
                  Verificado
                </span>
              </div>
              <div className="flex mb-1" data-id="element-1023">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-3 h-3 fill-[#D4AF37] text-[#D4AF37]" data-id="element-1024" />)}
              </div>
              <p className="text-sm font-bold text-gray-900 leading-snug" data-id="element-1025">
                "Perdí 6 kg y 8 cm de cintura en 3 semanas."
              </p>
              <p className="text-xs text-gray-500 mt-1" data-id="element-1026">— Carmen M., 42 años</p>
            </motion.div>

            {/* Second floating badge */}
            <motion.div animate={{
            y: [0, 5, 0]
          }} transition={{
            duration: 3.5,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 1
          }} className="absolute -top-4 -right-4 bg-[#2D5016] text-white rounded-2xl p-3 shadow-xl" data-id="element-1027">
              <p className="text-2xl font-black text-[#D4AF37]" data-id="element-1028">-8 kg</p>
              <p className="text-xs text-green-200" data-id="element-1029">media en 21 días</p>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}